
import { supabase } from '@/integrations/supabase/client';

export const addUserToClientVisibility = async (clientId: string, userId: string) => {
  console.log(`Adding user ${userId} to client ${clientId} visibility`);
  
  const { data, error } = await supabase
    .from('clients')
    .select('visible_to')
    .eq('id', clientId)
    .single();

  if (error) {
    console.error(`Error fetching client ${clientId}:`, error);
    throw error;
  }

  console.log(`Current visible_to for client ${clientId}:`, data.visible_to);

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  if (currentVisibleTo.includes(userId)) {
    console.log(`User ${userId} already has access to client ${clientId}`);
    return; // User already has access
  }

  const updatedVisibleTo = [...currentVisibleTo, userId];
  console.log(`Updated visible_to for client ${clientId}:`, updatedVisibleTo);

  const { error: updateError } = await supabase
    .from('clients')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', clientId);

  if (updateError) {
    console.error(`Error updating client ${clientId}:`, updateError);
    throw updateError;
  }

  console.log(`Successfully added user ${userId} to client ${clientId} visibility`);
};

export const removeUserFromClientVisibility = async (clientId: string, userId: string) => {
  const { data, error } = await supabase
    .from('clients')
    .select('visible_to')
    .eq('id', clientId)
    .single();

  if (error) throw error;

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  const updatedVisibleTo = currentVisibleTo.filter((id: string) => id !== userId);

  const { error: updateError } = await supabase
    .from('clients')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', clientId);

  if (updateError) throw updateError;
};

export const addUserToApprovalVisibility = async (approvalId: string, userId: string) => {
  console.log(`Adding user ${userId} to approval ${approvalId} visibility`);
  
  const { data, error } = await supabase
    .from('approval_posts')
    .select('visible_to')
    .eq('id', approvalId)
    .single();

  if (error) {
    console.error(`Error fetching approval ${approvalId}:`, error);
    throw error;
  }

  console.log(`Current visible_to for approval ${approvalId}:`, data.visible_to);

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  if (currentVisibleTo.includes(userId)) {
    console.log(`User ${userId} already has access to approval ${approvalId}`);
    return; // User already has access
  }

  const updatedVisibleTo = [...currentVisibleTo, userId];
  console.log(`Updated visible_to for approval ${approvalId}:`, updatedVisibleTo);

  const { error: updateError } = await supabase
    .from('approval_posts')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', approvalId);

  if (updateError) {
    console.error(`Error updating approval ${approvalId}:`, updateError);
    throw updateError;
  }

  console.log(`Successfully added user ${userId} to approval ${approvalId} visibility`);
};

export const removeUserFromApprovalVisibility = async (approvalId: string, userId: string) => {
  const { data, error } = await supabase
    .from('approval_posts')
    .select('visible_to')
    .eq('id', approvalId)
    .single();

  if (error) throw error;

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  const updatedVisibleTo = currentVisibleTo.filter((id: string) => id !== userId);

  const { error: updateError } = await supabase
    .from('approval_posts')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', approvalId);

  if (updateError) throw updateError;
};

export const addUserToGoalVisibility = async (goalId: string, userId: string) => {
  console.log(`Adding user ${userId} to goal ${goalId} visibility`);
  
  const { data, error } = await supabase
    .from('goals')
    .select('visible_to')
    .eq('id', goalId)
    .single();

  if (error) {
    console.error(`Error fetching goal ${goalId}:`, error);
    throw error;
  }

  console.log(`Current visible_to for goal ${goalId}:`, data.visible_to);

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  if (currentVisibleTo.includes(userId)) {
    console.log(`User ${userId} already has access to goal ${goalId}`);
    return; // User already has access
  }

  const updatedVisibleTo = [...currentVisibleTo, userId];
  console.log(`Updated visible_to for goal ${goalId}:`, updatedVisibleTo);

  const { error: updateError } = await supabase
    .from('goals')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', goalId);

  if (updateError) {
    console.error(`Error updating goal ${goalId}:`, updateError);
    throw updateError;
  }

  console.log(`Successfully added user ${userId} to goal ${goalId} visibility`);
};

export const removeUserFromGoalVisibility = async (goalId: string, userId: string) => {
  const { data, error } = await supabase
    .from('goals')
    .select('visible_to')
    .eq('id', goalId)
    .single();

  if (error) throw error;

  const currentVisibleTo = Array.isArray(data.visible_to) ? data.visible_to : [];
  const updatedVisibleTo = currentVisibleTo.filter((id: string) => id !== userId);

  const { error: updateError } = await supabase
    .from('goals')
    .update({ visible_to: updatedVisibleTo })
    .eq('id', goalId);

  if (updateError) throw updateError;
};

// Nova função para adicionar colaborador a todos os registros da empresa de uma vez
export const addCollaboratorToAllCompanyRecords = async (companyId: string, collaboratorId: string) => {
  console.log(`Adding collaborator ${collaboratorId} to all records of company ${companyId}`);
  
  try {
    // Adicionar a todos os clientes
    console.log('Fetching clients for company:', companyId);
    const { data: clients, error: clientsError } = await supabase
      .from('clients')
      .select('id, visible_to')
      .eq('company_id', companyId);

    if (clientsError) {
      console.error('Error fetching clients:', clientsError);
    } else if (clients) {
      console.log(`Found ${clients.length} clients to update`);
      for (const client of clients) {
        console.log(`Processing client ${client.id}, current visible_to:`, client.visible_to);
        
        const currentVisibleTo = Array.isArray(client.visible_to) ? client.visible_to : [];
        if (!currentVisibleTo.includes(collaboratorId)) {
          const updatedVisibleTo = [...currentVisibleTo, collaboratorId];
          console.log(`Updating client ${client.id} visible_to to:`, updatedVisibleTo);
          
          const { error: updateError } = await supabase
            .from('clients')
            .update({ visible_to: updatedVisibleTo })
            .eq('id', client.id);
            
          if (updateError) {
            console.error(`Error updating client ${client.id}:`, updateError);
          } else {
            console.log(`Successfully added collaborator to client ${client.id}`);
          }
        } else {
          console.log(`Collaborator already has access to client ${client.id}`);
        }
      }
    }

    // Adicionar a todas as aprovações
    console.log('Fetching approvals for company:', companyId);
    const { data: approvals, error: approvalsError } = await supabase
      .from('approval_posts')
      .select('id, visible_to')
      .eq('company_id', companyId);

    if (approvalsError) {
      console.error('Error fetching approvals:', approvalsError);
    } else if (approvals) {
      console.log(`Found ${approvals.length} approvals to update`);
      for (const approval of approvals) {
        console.log(`Processing approval ${approval.id}, current visible_to:`, approval.visible_to);
        
        const currentVisibleTo = Array.isArray(approval.visible_to) ? approval.visible_to : [];
        if (!currentVisibleTo.includes(collaboratorId)) {
          const updatedVisibleTo = [...currentVisibleTo, collaboratorId];
          console.log(`Updating approval ${approval.id} visible_to to:`, updatedVisibleTo);
          
          const { error: updateError } = await supabase
            .from('approval_posts')
            .update({ visible_to: updatedVisibleTo })
            .eq('id', approval.id);
            
          if (updateError) {
            console.error(`Error updating approval ${approval.id}:`, updateError);
          } else {
            console.log(`Successfully added collaborator to approval ${approval.id}`);
          }
        } else {
          console.log(`Collaborator already has access to approval ${approval.id}`);
        }
      }
    }

    // Adicionar a todas as metas
    console.log('Fetching goals for company:', companyId);
    const { data: goals, error: goalsError } = await supabase
      .from('goals')
      .select('id, visible_to')
      .eq('company_id', companyId);

    if (goalsError) {
      console.error('Error fetching goals:', goalsError);
    } else if (goals) {
      console.log(`Found ${goals.length} goals to update`);
      for (const goal of goals) {
        console.log(`Processing goal ${goal.id}, current visible_to:`, goal.visible_to);
        
        const currentVisibleTo = Array.isArray(goal.visible_to) ? goal.visible_to : [];
        if (!currentVisibleTo.includes(collaboratorId)) {
          const updatedVisibleTo = [...currentVisibleTo, collaboratorId];
          console.log(`Updating goal ${goal.id} visible_to to:`, updatedVisibleTo);
          
          const { error: updateError } = await supabase
            .from('goals')
            .update({ visible_to: updatedVisibleTo })
            .eq('id', goal.id);
            
          if (updateError) {
            console.error(`Error updating goal ${goal.id}:`, updateError);
          } else {
            console.log(`Successfully added collaborator to goal ${goal.id}`);
          }
        } else {
          console.log(`Collaborator already has access to goal ${goal.id}`);
        }
      }
    }

    console.log(`Finished adding collaborator ${collaboratorId} to all company records`);
    return true;
  } catch (error) {
    console.error('Error in addCollaboratorToAllCompanyRecords:', error);
    throw error;
  }
};
